export const DEPARTMENT = {
  TAX_PREPARER: 1,
  CASHIER: 2,
  MANAGER: 3,
  DISTRICT_MANAGER: 4,
  ACCOUNTANT: 5,
  ADMIN: 6,
  SUPER_ADMIN: 7,
};

const _DEPARTMENT_DESCRIPTION_MAP = {};
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.TAX_PREPARER] = 'Tax Preparer';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.CASHIER] = 'Cashier';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.MANAGER] = 'Manager';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.DISTRICT_MANAGER] = 'District Manager';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.ACCOUNTANT] = 'Accountant';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.ADMIN] = 'Admin';
_DEPARTMENT_DESCRIPTION_MAP[DEPARTMENT.SUPER_ADMIN] = 'Super Admin';

export const DEPARTMENT_DESCRIPTION_MAP = _DEPARTMENT_DESCRIPTION_MAP;

export default {
  DEPARTMENT,
  DEPARTMENT_DESCRIPTION_MAP,
};
